import React from 'react';
import { LoadingButton } from '@mui/lab';
import { Typography, ListItemSecondaryAction, ListItemText } from '@mui/material';
import I18n from '../../common/i18n/I18n';
import { useStyling } from '../../common/Theme';
import { getStringFromDateRange } from '../helpers/activityUtils';
import { PUNCTUATION_MARKS_CONSTANTS } from '../../common/constants/constants';
import { useBrowserOrAccountLocale } from '../../common/hooks/useBrowserOrAccountLocale';

const ListActionButtons = ({ isKeyDate, activityId, markActiivtyId, unmarkActivityId, isLoading, isDisabled }) => {
    const { theme } = useStyling();

    return (
        <ListItemSecondaryAction sx={{ display: 'flex', alignItems: 'center' }}> {/* Using flex instead of H until further information */}
            {isKeyDate && (
                <Typography sx={{ color: theme.palette.text.disabled, mr: 2 }}>
                    <I18n token="form.added" />
                </Typography>
            )}
            <LoadingButton
                variant="text"
                loading={isLoading.current.id === activityId && isLoading.current.isLoading}
                disabled={isDisabled}
                onClick={(e) => {
                    isKeyDate ? unmarkActivityId(activityId) : markActiivtyId(activityId);
                    e.stopPropagation();
                }}
            >
                {isKeyDate ? <I18n token="form.remove" /> : <I18n token="form.add" />}
            </LoadingButton>
        </ListItemSecondaryAction>
    );
};

type ActivityListTileType = {
    item: Record<string, any>;
    markActiivtyId: (id: string) => void;
    unmarkActivityId: (id: string) => void;
    isLoading: boolean;
    isDisabled?: boolean;
}

export default (props: ActivityListTileType) => {
    const { item: activity, markActiivtyId, unmarkActivityId, isLoading, isDisabled = false } = props;
    const { theme } = useStyling();
    const locale = useBrowserOrAccountLocale()

    return (
        activity && (
            <React.Fragment key={activity.id}>
                <ListItemText
                    primary={<Typography>{activity?.name}</Typography>}
                    secondary={
                        <Typography variant="body2" sx={{ color: theme.palette.text.disabled }}>
                            {activity?.dateRange && `${getStringFromDateRange(activity.dateRange,locale) || PUNCTUATION_MARKS_CONSTANTS.dash}`}
                        </Typography>
                    }
                
                />
                <ListActionButtons
                    isKeyDate={activity?.isKeyDate}
                    activityId={activity.id}
                    markActiivtyId={markActiivtyId}
                    unmarkActivityId={unmarkActivityId}
                    isLoading={isLoading}
                    isDisabled={isDisabled}
                />
            </React.Fragment>
        )
    );
};
